"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var banner_one_jpg_1 = __importDefault(require("../assets/images/banner_one.jpg"));
var banner_two_jpg_1 = __importDefault(require("../assets/images/banner_two.jpg"));
var banner_three_jpg_1 = __importDefault(require("../assets/images/banner_three.jpg"));
var banner_four_jpg_1 = __importDefault(require("../assets/images/banner_four.jpg"));
var react_id_swiper_1 = __importDefault(require("react-id-swiper"));
require("swiper/css/swiper.css");
require("../assets/styles/bannerStyle.css");
var core_1 = require("@material-ui/core");
var slides = [
    { image: banner_one_jpg_1.default },
    { image: banner_two_jpg_1.default },
    { image: banner_three_jpg_1.default },
    { image: banner_four_jpg_1.default }
];
var BannerLayout = function () {
    var params = {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    };
    return (react_1.default.createElement(core_1.Container, { maxWidth: "xl" },
        react_1.default.createElement(react_id_swiper_1.default, __assign({}, params), slides.map(function (_a, index) {
            var image = _a.image;
            return (react_1.default.createElement("div", { key: index },
                " ",
                react_1.default.createElement("img", { src: image }),
                " "));
        }))));
};
exports.default = BannerLayout;
